import { flowIdBikmoOfferFlow } from '../../../../flows/src/constants/flowIds';
import useFlowsInitNew from '../../../../flows/src/hooks/init/useFlowsInitNew';
import useFlowsResetState from '../../../../flows/src/hooks/useFlowsResetState';

const useStartBikmoOfferFlow = (): ((uuid: string) => Promise<void>) => {
  const { initFlow } = useFlowsInitNew();
  const { reset } = useFlowsResetState();

  return async (uuid?: string) => {
    reset();

    const flowPayload = {
      // company: ['bikmo'],
      // insurance_type: ['bicycle'],
    };

    await initFlow({
      flowId: flowIdBikmoOfferFlow,
      payload: flowPayload,
      outputUrl: `/sales-conversation/offers/overview/bicycle`,
      sessionId: uuid,
    });
  };
};

export default useStartBikmoOfferFlow;
